// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__95XBD","question":"styles_question__2F4O_","inputVisibleButton":"styles_inputVisibleButton__20o5-","note":"styles_note__24bcB"};